<template>
  <b-form-group
    label="Kategori Seviyesi"
    label-for="id_product_categories"
  >
    <validation-provider
      #default="{ errors }"
      name="Kategori Seviyesi"
      rules=""
    >
      <v-select
        v-model="dataItem.id_product_categories"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Ana Kategori"
      >
        <template v-slot:option="option">
          <div>
            {{ option.title }}
          </div>
          <div>
            <template v-if="option.id_product_categories">
              <b-badge
                variant="light-primary"
                class="mr-1"
              >
                <feather-icon icon="CornerDownRightIcon" />
                {{ option.mainProductCategory.title }}
              </b-badge>
              <b-badge variant="light-secondary">
                <feather-icon icon="CornerRightDownIcon" />
                Alt Kategori Seviyesi
              </b-badge>
            </template>
            <template v-else>
              <b-badge
                variant="light-primary"
                class="mr-1"
              >
                <feather-icon icon="CornerDownRightIcon" />
                Ana Kategori
              </b-badge>
              <b-badge variant="light-secondary">
                <feather-icon icon="CornerRightDownIcon" />
                Alt Kategori Seviyesi
              </b-badge>
            </template>
          </div>
        </template>
        <template v-slot:selected-option="option">
          {{ option.title }}
          <template v-if="option.id_product_categories">
            <b-badge
              variant="light-primary"
              class="mr-1 ml-1"
            >
              <feather-icon icon="CornerLeftUpIcon" />
              {{ option.mainProductCategory.title }}
            </b-badge>
            <b-badge variant="light-secondary">
              <feather-icon icon="CornerRightDownIcon" />
              Alt Kategori Seviyesi
            </b-badge>
          </template>
          <template v-else>
            <b-badge
              variant="light-primary"
              class="mr-1 ml-1"
            >
              <feather-icon icon="CornerLeftUpIcon" />
              Ana Kategori
            </b-badge>
            <b-badge variant="light-secondary">
              <feather-icon icon="CornerRightDownIcon" />
              Alt Kategori Seviyesi
            </b-badge>
          </template>
        </template>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BBadge,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ProductCategoriesCategorySelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
    BBadge,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['productCategories/dataList']
    },
    dataItem() {
      return this.$store.getters['productCategories/dataItem']
    },
  },
  created() {
    localize('tr')
    this.getDataList()
  },
  methods: {
    getDataList() {
      const param = {
        select: {
          id: true,
          title: true,
          id_product_categories: true,
          mainProductCategory: {
            select: {
              title: true,
            },
          },
        },
        where: {
          id_product_categories: null,
        },
      }
      if (this.$route.params.id) {
        param.where.id = {
          not: Number(this.$route.params.id),
        }
      }
      this.$store.dispatch('productCategories/getDataList', param)
    },
  },
}
</script>
